import { useMemo } from "react";
import {
  byPrimaryVoltage,
  primaryVoltageKeysDesc,
  type TransformerTypeReference,
  type TransformerPhase,
  type TransformerMounting,
} from "./TransformerTypesByPrimaryVoltage";

export function useTransformerTypesByPrimaryVoltage(
  types: TransformerTypeReference[],
  mounting: TransformerMounting,
  numberOfPhases: TransformerPhase,
  primaryVoltagekV: number,
) {
  const { keys, selected } = useMemo(() => {
    const map = byPrimaryVoltage(types, mounting, numberOfPhases);
    const keys = primaryVoltageKeysDesc(map);
    const selected = map.get(Number(primaryVoltagekV)) ?? [];
    return { keys, selected };
  }, [types, mounting, numberOfPhases, primaryVoltagekV]);

  return {
    primaryVoltageKeysDesc: keys,
    transformerTypesForPrimaryVoltage: selected,
  };
}

export type { TransformerTypeReference, TransformerMounting, TransformerPhase };
